// Zweck: Lagerzugriffe über den bestehenden Anmelde- und Proxyweg.
// Kontext: Keine Lagerlogik im Express-Server. Stand: 20.10.2026.
import one360 from './one360';
import type { WarehouseHeroResult } from '../../interfaces/warehouseHero';
import type {
  WarehouseTransport,
  WarehouseSnapshot,
  WarehouseResult,
} from '../../interfaces/warehouse';
const base = '/api/v1/ops/warehouse';
export const warehouseApi: WarehouseTransport = {
  syncHero: (articleId, mode, clarification) =>
    one360.post<WarehouseHeroResult>(`${base}/hero`, {
      articleId,
      mode,
      ...clarification,
    }),
  snapshot: () =>
    one360.get<WarehouseSnapshot>(`${base}/snapshot?pageBookings=true`),
  history: (before) =>
    one360.get<WarehouseSnapshot>(
      `${base}/bookings?before=${encodeURIComponent(before)}`,
    ),
  status: async (id) =>
    (
      await one360.get<WarehouseSnapshot>(
        `${base}/bookings/${encodeURIComponent(id)}`,
      )
    ).bookings.find((x) => x.requestId === id),
  book: (booking) => one360.post<WarehouseResult>(`${base}/bookings`, booking),
};
